import { createFeatureSelector, createSelector } from '@ngrx/store';
import { USER_FEATURE, UserState } from './user.reducer';

export const selectUserState = createFeatureSelector<UserState>(USER_FEATURE);
export const user = createSelector(
  selectUserState,
  (state: UserState) => state.user
);
